import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/**
 * AdminRouteGuard - Protects admin-only routes
 * Redirects non-admin users to customer dashboard
 * Redirects unauthenticated users to admin login
 */
export default function AdminRouteGuard({ children }) {
  const { user, loading } = useAuth()

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // No user - redirect to admin login
  if (!user) {
    return <Navigate to="/admin-login" replace />
  }

  // User exists but not admin - redirect to customer dashboard
  const adminToken = localStorage.getItem('admin_auth_token')
  if (!user.isAdmin || !adminToken) {
    return <Navigate to="/customer-dashboard" replace />
  }

  // Admin user with valid token - allow access
  return children
}